import { Ref } from 'vue';
import { keepPreviousData, useInfiniteQuery } from '@tanstack/vue-query';
import { AxiosResponse } from 'axios';

import { api } from '@/api/_http';
import { ApiError } from '@/types/commonApiType';

import { MonthlyCapture } from './master';

type GetCompanyAnalysisParams = Ref<{
	tab: string;
	view: number;
	sub?: string;
	category?: string;
}>;

type GetCompanyAnalysisData = {
	base_date: string;
	company_analysis: MonthlyCapture[];
	count: number;
};

export const useGetCompanyAnalysisInfiniteApi = (params: GetCompanyAnalysisParams) => {
	const url = '/v1/front/usa/getCompanyAnalysis';
	return useInfiniteQuery<
		{ data: GetCompanyAnalysisData },
		ApiError,
		GetCompanyAnalysisData,
		[string, GetCompanyAnalysisParams]
	>({
		queryKey: [url, params],
		queryFn: async ({ pageParam = 1 }) => {
			const res = await api.get<AxiosResponse<GetCompanyAnalysisData>>(url, {
				tab: params.value.tab,
				page: pageParam,
				row: params.value.view,
			});
			return res.data;
		},
		initialPageParam: 1,
		getNextPageParam: (lastPage: { data: GetCompanyAnalysisData }, allPages: { data: GetCompanyAnalysisData }[]) => {
			// Last Page Check
			const totalItem = lastPage.data.count;
			const currentItem = allPages.length * 10;
			const isNext = totalItem > currentItem ? true : null;

			return isNext && allPages.length + 1;
		},
		select: (res) => {
			// alram page format
			const companyAnalysisList = res.pages.reduce<MonthlyCapture[]>((prev, cur) => {
				return [...prev, ...cur.data.company_analysis];
			}, []);

			return {
				count: res.pages[0].data.count ?? 0,
				base_date: res.pages[0].data.base_date ?? '',
				company_analysis: companyAnalysisList,
			};
		},
		placeholderData: keepPreviousData,
	});
};

export const useGetCompanyAnalysisInfiniteApi_KR = (params: GetCompanyAnalysisParams) => {
	const url = '/v1/front/getCompanyAnalysis';
	return useInfiniteQuery<
		{ data: GetCompanyAnalysisData },
		ApiError,
		GetCompanyAnalysisData,
		[string, GetCompanyAnalysisParams]
	>({
		queryKey: [url, params],
		queryFn: async ({ pageParam = 1 }) => {
			const res = await api.get<AxiosResponse<GetCompanyAnalysisData>>(url, {
				tab: params.value.tab,
				sub: params.value.sub,
				category: params.value.category,
				page: pageParam,
				row: params.value.view,
			});
			return res.data;
		},
		initialPageParam: 1,
		getNextPageParam: (lastPage: { data: GetCompanyAnalysisData }, allPages: { data: GetCompanyAnalysisData }[]) => {
			// Last Page Check
			const totalItem = lastPage.data.count;
			const currentItem = allPages.length * 10;
			const isNext = totalItem > currentItem ? true : null;

			return isNext && allPages.length + 1;
		},
		select: (res) => {
			// alram page format
			const companyAnalysisList = res.pages.reduce<MonthlyCapture[]>((prev, cur) => {
				return [...prev, ...cur.data.company_analysis];
			}, []);

			return {
				count: res.pages[0].data.count ?? 0,
				base_date: res.pages[0].data.base_date ?? '',
				company_analysis: companyAnalysisList,
			};
		},
		placeholderData: keepPreviousData,
	});
};

export const useGetCompanyAnalysisInfiniteApi_JPN = (params: GetCompanyAnalysisParams) => {
	const url = '/v1/front/jpn/getCompanyAnalysis';
	return useInfiniteQuery<
		{ data: GetCompanyAnalysisData },
		ApiError,
		GetCompanyAnalysisData,
		[string, GetCompanyAnalysisParams]
	>({
		queryKey: [url, params],
		queryFn: async ({ pageParam = 1 }) => {
			const res = await api.get<AxiosResponse<GetCompanyAnalysisData>>(url, {
				tab: params.value.tab,
				page: pageParam,
				row: params.value.view,
			});
			return res.data;
		},
		initialPageParam: 1,
		getNextPageParam: (lastPage: { data: GetCompanyAnalysisData }, allPages: { data: GetCompanyAnalysisData }[]) => {
			// Last Page Check
			const totalItem = lastPage.data.count;
			const currentItem = allPages.length * 10;
			const isNext = totalItem > currentItem ? true : null;

			return isNext && allPages.length + 1;
		},
		select: (res) => {
			// alram page format
			const companyAnalysisList = res.pages.reduce<MonthlyCapture[]>((prev, cur) => {
				return [...prev, ...cur.data.company_analysis];
			}, []);

			return {
				count: res.pages[0].data.count ?? 0,
				base_date: res.pages[0].data.base_date ?? '',
				company_analysis: companyAnalysisList,
			};
		},
		placeholderData: keepPreviousData,
	});
};
